import { useSelector } from "react-redux";
import { useMain } from "../../actions/homeActions";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
export default () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const userData = useSelector((state) => state.app.userData.userData);
  const maincategoryId = useSelector(
    (state) => state.app.maincategoryId.maincategoryId
  );
  const {
    data: Singlecategor,
    isLoading,
    isError,
    error,
  } = useMain(maincategoryId);
  const handleTalent = (id) => {
    if (!isLoggedIn) {
      navigate("/login");
    } else if (userData?.role === "fan") {
      navigate("/upgrade");
    } else {
      navigate(`/talent/${id}`);
    }
  };
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading Category Detail: {error.message}
        </p>
      </div>
    );
  }

  return { isLoading, Singlecategor, handleTalent };
};
